import type { ErrorType } from '@/app/api/trpc/error-handlers';
import { TRPCClientError } from '@trpc/client';

interface ParsedError {
  errorType: ErrorType | null;
  userMessage: string | null;
}

export function parseTRPCError(error: unknown): ParsedError {
  if (error instanceof TRPCClientError) {
    return {
      errorType: error.data?.errorType ?? null,
      userMessage: error.data?.userMessage ?? null,
    };
  }
  return { errorType: null, userMessage: null };
}

export function getErrorType(error: unknown): ErrorType | null {
  return parseTRPCError(error).errorType;
}
